import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { TextArea } from '../../Controls/Input/TextArea';
import cn from './styles.module.scss';

export interface Props {
  defaultValue?: string;
  placeholder?: string;
  onSubmit: (commentText: string) => void;
  onChange?: (commentText: string) => void;
  onBlur?: (commentText: string) => void;
  isLoading?: boolean;
  className?: string;
}

export const CommentInput = React.forwardRef(({
  defaultValue = '',
  placeholder = 'Add a New Comment',
  onSubmit,
  onChange,
  onBlur,
  isLoading,
  className,
}: Props, ref) => {
  const [comment, setComment] = useState(defaultValue || '');

  useEffect(() => {
    setComment(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { target: { value } } = e;
    setComment(value);
    onChange?.(value);
  };

  const handleSubmit = (event: React.KeyboardEvent) => {
    if (event.shiftKey) {
      return;
    }

    onSubmit?.(comment);
    setComment('');
  };

  const handleBlur = () => {
    onBlur?.(comment);
  };

  return (
    <TextArea
      disabled={isLoading}
      rows={2}
      placeholder={placeholder}
      value={comment}
      onPressEnter={handleSubmit}
      onBlur={handleBlur}
      onChange={handleChange}
      className={classNames(cn.input, className)}
      ref={ref}
      data-testid="commentTextInput"
    />
  );
});
